<template>
  <div
    :id="`sidepanel-portal-${modeId}`"
    class="flex h-full min-h-0 flex-col"
  />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { registerPortalOutlet, useSidepanel } from "@/composables/useSidepanel";

// Generic body for modes whose content is owned by a view: the view keeps its
// state/bindings and <Teleport>s its markup here while the outlet is mounted.
// The mode id is captured at mount — during the slide transition a leaving
// outlet must keep its identity while the entering pane's selectedMode
// already points elsewhere.
const { selectedMode } = useSidepanel();
const modeId = selectedMode.value;

let release: (() => void) | null = null;
onMounted(() => {
  release = registerPortalOutlet(modeId);
});
onBeforeUnmount(() => release?.());
</script>
